import { CompanyAPI } from '@api/buser-http-client';

const acceptContract = () => CompanyAPI.acceptContract()
  .then((data) => data)
  .catch((error) => Promise.reject(error.response?.data || error.response));

export { acceptContract };
